import { Component, OnInit } from '@angular/core';
import { UserModel } from "../../../../../model/user.model";
import { AuthenticationService } from "../../../../../service/auth.service";
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent extends ComponentBase implements OnInit {

  user: UserModel;

  constructor(private authService: AuthenticationService) { super() }

  ngOnInit() {
    this.user = this.authService.getUser();

    let autofill = this.attribute.options
      .some(opt => opt.key.toLowerCase() == "autofill" &&
                   opt.value.toLowerCase() == "true")

    if (this.user && !this.attribute.value && autofill) {
      this.attribute.value = this.user.userName;
      let userAttribute = new AttributeModel();
      userAttribute.key = "userName";
      userAttribute.value = this.user.userName;
      userAttribute.type = "text";
      this.attribute.attributes.push(userAttribute);

      userAttribute = new AttributeModel();
      userAttribute.key = "userFullName";
      userAttribute.value = this.user.name;
      userAttribute.type = "text";
      this.attribute.attributes.push(userAttribute);

      userAttribute = new AttributeModel();
      userAttribute.key = "mail";
      userAttribute.value = this.user.email;
      userAttribute.type = "text";
      this.attribute.attributes.push(userAttribute);

      let attributes: AttributeModel[] = []

      if(this.user.roles) {
        for (const roleName of this.user.roles) {
          let attribute = new AttributeModel()
          attribute.key = "role"
          attribute.value = roleName
          attribute.type = "text"
          attributes.push(attribute);
        }
      }

      userAttribute = new AttributeModel();
      userAttribute.key = "role";
      userAttribute.value = "";
      userAttribute.type = "text";
      userAttribute.attributes = attributes;
      this.attribute.attributes.push(userAttribute);
    }
  }

  getOptionByKey(attribute: AttributeModel, key: string): string {
    let baseResult = super.getOptionByKey(attribute, key)

    if(baseResult) {
      return baseResult
    }

    return "false"
  }
}
